export interface TariffDto {
  discount?: number;
  grains?: number;
  month?: number;
  monthUserPrice?: number;
  users?: number;
  exportCredits?: number;
  price?: number;
  name?: TariffName;
  active?: boolean;
  custom?: boolean;
  notShowDiscount?: boolean;
  pricePerLinkedinSlot?: number;
  linkedinSlots?: number;
  linkedinSlotsDiscount?: number;
  linkedinSlotsDiscountPercent?: number;
  linkedinSlotsTotalPrice?: number;
  totalPrice?: number;
  contactCredits?: number;
  usageDiscount?: number;
  usageDiscountPercent?: number;
  usageTotalPrice?: number;
}

export interface TariffsByMonthsAsset {
  [month: number]: TariffDto[];
}

export interface TariffGettingInfo {
  currentTariffName?: TariffName;
  nextTariffName?: TariffName;
  currentTariff?: TariffDto;
  nextTariff?: TariffDto;
  isCurrentTariffBigger?: boolean;
  currentTariffIndex?: number;
  nextTariffIndex?: number;
  isNextTariffNotChangeable?: boolean;
}

export interface ChangeTariffMessageParams {
  price?: number;
  monthsExpression?: string;
  usersExpression?: string;
  date?: string;
}

export interface ChangeTariffMonthInfo {
  monthNumber: number;
  activeTariffIndex: number;
}

export type TariffName = 'free' | string;

export type TariffPlanName = 'free' | 'trial' | 'pro';

export enum TariffBtnEnum {
  TRY_FREE_WEEK_TRIAL = 'try-free-week-trial',
  PAY_FOR_PLAN = 'pay-for-plan',
}
export interface ChangeTariffInfo {
  currentTariffName: string;
  nextTariffName: TariffName;
  isUserFree: boolean;
  btnType?: TariffBtnEnum;
}
